angular.module('leanlaw').controller('ContingencyExpenseReportCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.format = {};
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    // Matter term
    const matter = $scope.me.terms.Matter;
    // Exporting clients/matters
    var exp = $scope.data.filteredClients.reduce((accum, c) => {
      let clientItem = {
        "Client": c.client.label || c.client.name,
        [matter]: ""
      };
      c.periods.forEach(p => {
        clientItem[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
      });
      clientItem['Total'] = c.data.display || 0;
      accum.push(clientItem);
      if ($scope.filter.include.matters) {
        c.matters.forEach(m => {
          let matterItem = {
            "Client": "",
            [matter]: m.matter.label || m.matter.name
          };
          m.periods.forEach(p => {
            matterItem[p.period.label] = p.data.display === '-' ? 0 : p.data.display;
          });
          matterItem['Total'] = m.data.display || 0;
          accum.push(matterItem);
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  var _query;
  function filterClientEntries() {
    if (!$scope.filter.period) return;
    var query = reportsService.queryFromFilter($scope.filter);
    query.data = "expenses";
    query.billed = false;
    query.billedState = undefined;
    query.billingType = "contingency";
    query.expenseInterest = true;
    query.zeros = false;
    query.primary = 'clients';
    query.secondary = 'period';
    query.period = $scope.filter.period.period;
    if ($scope.filter.period.range.startDate) {
      query.startDate = $scope.filter.period.range.startDate;
      query.endDate = $scope.filter.period.range.endDate;
    } else {
      query.startDate = $scope.filter.period.range.startPeriod.startDate;
      query.endDate = $scope.filter.period.range.endPeriod.endDate;
    }

    // This prevents reloading data when we change filters that don't impact the query
    // such as the property and matters-include filters
    if (_query && _query === JSON.stringify(query)) {
      return;
    }
    _query = JSON.stringify(query);
    $scope.loading = true;
    singleRequest.apiCall("filterClientEntries").getReport(query).then(data => {
      if (!data) return;
      $scope.data = data;
      adjustData(data, 'amounts', 'total', 'amount');
      $scope.loading = false;
    }).catch(err => {
      console.log(err);
      $scope.loading = false;
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("filterClientEntries");
    deactivate();
  });
  function adjustData(data, p1, p2, filter) {
    if (!data) return;
    var d = data.data;
    if (d) {
      var number = d[p1][p2];
      d.display = number ? $filter(filter)(number) : '-';
    }
    adjustList(data.clients, p1, p2, filter);
    adjustList(data.matters, p1, p2, filter);
    adjustList(data.users, p1, p2, filter);
    adjustList(data.periods, p1, p2, filter);
  }
  function adjustList(list, p1, p2, filter) {
    if (!list) return;
    list.forEach(i => adjustData(i, p1, p2, filter));
  }
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    // Assigning to existing filter keeps custom filter options
    $scope.filter = Object.assign($scope.filter, payload);
    // Necessary to set this value for the requests
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    filterClientEntries();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);
    filterClientEntries();
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);